import React, { useRef, useState } from 'react';
import PdfViewerFirst from './screen/firstPage/pdfViewerFirst';
import PdfViewerSecond from './screen/secondPage/pdfViewerSecond';
import PdfViewerThird from './screen/thirdPage/pdfViewerThird';
import PdfViewerFourth from './screen/fourthPage/pdfViewerFourth';
import PdfViewerFifth from './screen/fifthPage/pdfViewerFifth'; // Novo
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Box, Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import FormsProposalFirst from './screen/firstPage/formsProposalFirst';
import FormsProposalSecond from './screen/secondPage/formsProposalSecond';
import FormsProposalThird from './screen/thirdPage/formsProposalThird';
import FormsProposalFourth from './screen/fourthPage/formsProposalFourth';
import FormsProposalFifth from './screen/fifthPage/formsProposalFifth'; // Novo
import ConfirmationPage from './screen/confirmationPage/confirmatioPage';

export default function PropostaComercial() {
  const [formData, setFormData] = useState<{
    subTitle: string;
    wallpaper: File | null;
    logos: (File | null)[];
  }>({
    subTitle: '',
    wallpaper: null,
    logos: [],
  });

  const [formDataSecondPage, setFormDataSecondPage] = useState<{
    image1: File | null;
    image2: File | null;
  }>({
    image1: null,
    image2: null,
  });
  const [formDataThirdPage, setFormDataThirdPage] = useState<{}>({});
  const [formDataFourthPage, setFormDataFourthPage] = useState<{
    imagePage4: File | null;
    monthlyCall?: string;
  }>({
    imagePage4: null,
  });
  const [formDataFifthPage, setFormDataFifthPage] = useState<{
    notes: string;
    implementationFee: string;
  }>({
    notes: '',
    implementationFee: '',
  });
  const [servicesRows, setServicesRows] = useState<
    {
      recurso: string;
      qtde: string;
      meses12: string;
      meses24: string;
      meses36: string;
      meses48: string;
      meses60: string;
    }[]
  >([]);

  const [page, setPage] = useState<
    'first' | 'second' | 'third' | 'fourth' | 'fifth' | 'confirmation'
  >('first');
  const pdfRefFirst = useRef<HTMLDivElement>(null);
  const pdfRefSecond = useRef<HTMLDivElement>(null);
  const pdfRefThird = useRef<HTMLDivElement>(null);
  const pdfRefFourth = useRef<HTMLDivElement>(null);
  const pdfRefFifth = useRef<HTMLDivElement>(null);
  const [pdfPages, setPdfPages] = useState<string[]>([]);
  const [formType, setFormType] = React.useState<'completo' | 'simples'>(
    'simples',
  );
  const [savedPages, setSavedPages] = useState<string[]>([]); // Novo estado

  const renderPageToImage = async (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const canvas = await html2canvas(ref.current, {
        scale: 3,
        useCORS: true,
        backgroundColor: '#fff',
        width: ref.current.offsetWidth,
        height: ref.current.offsetHeight,
      } as any);
      return canvas.toDataURL('image/png', 1.0);
    }
    return null;
  };

  const generatePdf = async () => {
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const mmWidth = 210;
    const mmHeight = 297;

    for (let i = 0; i < pdfPages.length; i++) {
      if (i !== 0) pdf.addPage();
      const imgData = pdfPages[i];
      if (!imgData) continue;
      const img = new window.Image();
      img.src = imgData;
      await new Promise((resolve) => {
        img.onload = () => {
          const imgWidth = mmWidth;
          const imgHeight = (img.height * mmWidth) / img.width;
          const y = (mmHeight - imgHeight) / 2;
          pdf.addImage(
            imgData,
            'PNG',
            0,
            y,
            imgWidth,
            imgHeight,
            undefined,
            'FAST',
          );
          resolve(true);
        };
      });
    }

    pdf.save('proposta.pdf');
  };

  const markPageAsSaved = (page: string) => {
    setSavedPages((prev) => (prev.includes(page) ? prev : [...prev, page]));
  };

  const goToNextPage = async () => {
    let ref: React.RefObject<HTMLDivElement> | null = null;
    if (page === 'first') ref = pdfRefFirst;
    else if (page === 'second') ref = pdfRefSecond;
    else if (page === 'third') ref = pdfRefThird;
    else if (page === 'fourth') ref = pdfRefFourth;
    else if (page === 'fifth') ref = pdfRefFifth;

    if (ref) {
      const imgData = await renderPageToImage(ref);
      if (imgData) {
        setPdfPages((prev) => {
          const nextPages = [...prev];
          const idx =
            page === 'first'
              ? 0
              : page === 'second'
                ? 1
                : page === 'third'
                  ? 2
                  : page === 'fourth'
                    ? 3
                    : page === 'fifth'
                      ? 4
                      : 5;
          nextPages[idx] = imgData;
          return nextPages;
        });
        markPageAsSaved(page); // Marcar a página como salva
      }
    }

    setPage((prev) => {
      if (prev === 'first') return 'second';
      if (prev === 'second') return 'third';
      if (prev === 'third') return 'fourth';
      if (prev === 'fourth') return 'fifth';
      if (prev === 'fifth') return 'confirmation';
      return prev;
    });
  };

  const handleFormChange = (data: {
    subTitle?: string;
    wallpaper?: File | null;
    logos?: (File | null)[];
  }) => {
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const handleFormChangeSecondPage = (data: {
    image1?: File | null;
    image2?: File | null;
  }) => {
    setFormDataSecondPage((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const handleFormChangeThirdPage = (data: {}) => {
    setFormDataThirdPage((prev) => ({
      ...prev,
      ...data,
    }));
  };
  const handleFormChangeFourthPage = (data: {
    imagePage4?: File | null;
    monthlyCall?: string;
  }) => {
    setFormDataFourthPage((prev) => ({
      ...prev,
      ...data,
    }));
  };
  const handleFormChangeFifthPage = (data: {
    notes?: string;
    image?: File | null;
    nome?: string;
    cnpj?: string;
    data?: string;
  }) => {
    setFormDataFifthPage((prev) => ({
      ...prev,
      ...data,
    }));
  };

  return (
    <div
      className="flex items-center"
      style={{ width: '100%', height: '100%' }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'center',
          minHeight: '100vh',
          boxSizing: 'border-box',
          gap: { xs: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: '70%' },
            minWidth: { md: 350 },
            height: { xs: 'auto', md: '90vh' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            zIndex: 2,
            mb: { xs: 2, md: 0 },
          }}
        >
          <ToggleButtonGroup
            value={page}
            exclusive
            onChange={(event, newPage) => {
              if (newPage) {
                setPage(newPage);
              }
            }}
            sx={{
              marginBottom: 3,
              flexWrap: 'wrap',
              gap: 1,
              '.MuiToggleButton-root': {
                flex: 1,
                minWidth: 90,
                fontSize: { xs: '0.8rem', md: '1rem' },
                padding: { xs: '6px 8px', md: '8px 16px' },
              },
            }}
            fullWidth
          >
            {[
              'first',
              'second',
              'third',
              'fourth',
              'fifth',
              'confirmation',
            ].map((pageKey, index) => (
              <ToggleButton
                key={index}
                value={pageKey}
                sx={{
                  color: 'white',
                  backgroundColor: savedPages.includes(pageKey)
                    ? 'green'
                    : 'inherit', // Fundo verde se a página estiver salva
                  '&:hover': {
                    backgroundColor: savedPages.includes(pageKey)
                      ? 'darkgreen'
                      : 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                {`Página ${index + 1}`}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <Box
            sx={{
              width: '100%',
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              minHeight: 0,
              overflowY: 'auto',
            }}
          >
            {page === 'first' ? (
              <FormsProposalFirst
                formData={formData}
                onChange={handleFormChange}
                goToNextPage={goToNextPage}
              />
            ) : page === 'second' ? (
              <FormsProposalSecond
                formData={formDataSecondPage}
                onChange={handleFormChangeSecondPage}
                goToNextPage={goToNextPage}
              />
            ) : page === 'third' ? (
              <FormsProposalThird
                formData={formDataThirdPage}
                onChange={handleFormChangeThirdPage}
                goToNextPage={goToNextPage}
              />
            ) : page === 'fourth' ? (
              <FormsProposalFourth
                formData={formDataFourthPage}
                onChange={handleFormChangeFourthPage}
                goToNextPage={goToNextPage}
              />
            ) : page === 'fifth' ? (
              <FormsProposalFifth
                formData={formDataFifthPage}
                onChange={handleFormChangeFifthPage}
                goToNextPage={goToNextPage}
                servicesRows={servicesRows}
                setServicesRows={setServicesRows}
                formType={formType}
                setFormType={setFormType}
              />
            ) : (
              <ConfirmationPage generatePdf={generatePdf} />
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            height: { xs: 'auto', md: '100%' },
            width: { xs: '100%', md: '40%' },
            minWidth: { md: 320 },
            maxWidth: { md: 600 },
            justifyContent: 'center',
            alignItems: { xs: 'center', md: 'flex-start' },
            mt: { xs: 2, md: 0 },
            boxSizing: 'border-box',
          }}
        >
          {page === 'first' ? (
            <PdfViewerFirst formData={formData} boxRef={pdfRefFirst} />
          ) : page === 'second' ? (
            <PdfViewerSecond
              formData={formDataSecondPage}
              boxRef={pdfRefSecond}
              formaDataContext={{ logos: formData.logos }}
            />
          ) : page === 'third' ? (
            <PdfViewerThird
              formData={formDataSecondPage}
              boxRef={pdfRefThird}
              formaDataContext={{ logos: formData.logos }}
            />
          ) : page === 'fourth' ? (
            <PdfViewerFourth
              formData={formDataFourthPage}
              boxRef={pdfRefFourth}
              formaDataContext={{ logos: formData.logos }}
            />
          ) : page === 'fifth' ? (
            <PdfViewerFifth
              formData={formDataFifthPage}
              boxRef={pdfRefFifth}
              servicesRows={servicesRows}
              formType={formType}
              setFormType={setFormType}
            />
          ) : (
            <Box
              sx={{
                minHeight: '100%',
                aspectRatio: { xs: 'auto', md: '1 / 1.414' },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                overflowY: 'auto',
                width: '100%',
                gap: 2,
              }}
            >
              <PdfViewerFirst formData={formData} boxRef={pdfRefFirst} />
              <PdfViewerSecond
                formData={formDataSecondPage}
                boxRef={pdfRefSecond}
                formaDataContext={{ logos: formData.logos }}
              />
              <PdfViewerThird
                formData={formDataSecondPage}
                boxRef={pdfRefThird}
                formaDataContext={{ logos: formData.logos }}
              />
              <PdfViewerFourth
                formData={formDataFourthPage}
                boxRef={pdfRefFourth}
                formaDataContext={{ logos: formData.logos }}
              />
              <PdfViewerFifth
                formData={formDataFifthPage}
                boxRef={pdfRefFifth}
                servicesRows={servicesRows}
                formType={formType}
                setFormType={setFormType}
              />
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
}
